import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker"]
  static values = { postId: Number }

  connect() {
    this.dismissTimer = null
    this.longPressTimer = null
    this.pickerOpen = false
    this.preventScrollBound = this.preventScroll.bind(this)
  }

  showPicker() {
    clearTimeout(this.dismissTimer)
    this.pickerTarget.classList.add("reaction-picker--visible")
    if (!this.pickerOpen) {
      this.pickerOpen = true
      document.addEventListener("touchmove", this.preventScrollBound, { passive: false })
    }
  }

  hidePicker() {
    this.pickerTarget.classList.remove("reaction-picker--visible")
    this.pickerOpen = false
    document.removeEventListener("touchmove", this.preventScrollBound)
    this.clearActiveSlot()
  }

  scheduleDismiss() {
    this.dismissTimer = setTimeout(() => this.hidePicker(), 400)
  }

  preventScroll(event) {
    if (this.pickerOpen) {
      event.preventDefault()
    }
  }

  longPress(event) {
    // Prevent iOS zoom/callout and form submission on touch
    event.preventDefault()
    this._touched = true
    this.longPressTimer = setTimeout(() => {
      this._longPressed = true
      this.showPicker()
    }, 350)
  }

  cancelLongPress(event) {
    clearTimeout(this.longPressTimer)

    if (this._longPressed && this.pickerOpen) {
      // Long press: check if finger is over a picker slot
      const touch = event.changedTouches[0]
      const element = document.elementFromPoint(touch.clientX, touch.clientY)

      if (element) {
        const slot = element.closest(".reaction-picker__slot")
        if (slot) {
          const form = slot.querySelector("form")
          if (form) {
            form.requestSubmit()
            this.hidePicker()
            this._longPressed = false
            this._touched = false
            return
          }
        }
      }

      this.hidePicker()
    } else if (this._touched && !this._longPressed) {
      // Quick tap: toggle picker instead of submitting form
      if (this.pickerOpen) {
        this.hidePicker()
      } else {
        this.showPicker()
      }
    }

    this._longPressed = false
    this._touched = false
  }

  // Tracking do dedo sobre os slots para feedback visual
  touchMove(event) {
    if (!this.pickerOpen) return
    const touch = event.touches[0]
    const element = document.elementFromPoint(touch.clientX, touch.clientY)
    const slot = element ? element.closest(".reaction-picker__slot") : null

    this.clearActiveSlot()
    if (slot) {
      slot.classList.add("reaction-picker__slot--touched")
      this.activeSlot = slot
    }
  }

  clearActiveSlot() {
    if (this.activeSlot) {
      this.activeSlot.classList.remove("reaction-picker__slot--touched")
      this.activeSlot = null
    }
  }

  disconnect() {
    clearTimeout(this.dismissTimer)
    clearTimeout(this.longPressTimer)
    document.removeEventListener("touchmove", this.preventScrollBound)
  }
}
